module.exports = __webpack_public_path__ + "static/005-slideshow-20bb4080f5e05dc2c17acaced7615096.jpg";